import Hammer from "hammerjs";

class TextSlider {
  static SLIDE_BY_WIDE_SCREEN = 2;
  static SLIDE_BY_SMALL_SCREEN = 1;

  static SWIPE_SMALL = 1;
  static SWIPE_MEDIUM = 2;
  static SWIPE_LARGE = 3;


  constructor(sliderEl) {
    this.ui = {}
    this.ui.slider = sliderEl;
    this.ui.container = sliderEl.querySelector('.text-slider__container');
    this.ui.content = sliderEl.querySelector('.text-slider__items');
    this.ui.contentItems = this.ui.container.getElementsByClassName('text-slider__item');
    this.ui.prevButton = sliderEl.querySelector('.text-slider__control--prev');
    this.ui.nextButton = sliderEl.querySelector('.text-slider__control--next');

    this.containerWidth = this.ui.container.offsetWidth;
    this.minItemIndex = 0;
    this.maxItemIndex = this.ui.contentItems.length - 1;

    this.prepareContentItemData()
    this.setActiveItem(0)
    this.setListeners()

    const mediaQuery = window.matchMedia('(max-width: 480px)')
    if (mediaQuery.matches) {    
      this.enableSwipes()
    }
  }


  // Для каждого слайда расчитываем ширину и величину смещения от левой границы контейнера
  prepareContentItemData() {

    this.contentItemsData = [];

    for (var i = 0, totalWidth = 0; i < this.ui.contentItems.length; i++) {
      const item = this.ui.contentItems[i];

      const cs = window.getComputedStyle(item);

      const itemFullWidth = parseFloat(cs.getPropertyValue('margin-left')) +
        item.offsetWidth +
        parseFloat(cs.getPropertyValue('margin-right'));

      this.contentItemsData.push({
        width: itemFullWidth,
        left: totalWidth
      })
      totalWidth = totalWidth + itemFullWidth;
    }

    // console.log(this.contentItemsData);
    
  }


  setListeners() {
    
    const that = this

    function windowResizeHandler(e) {
      if (that.containerWidth != that.ui.container.offsetWidth) {
        that.containerWidth = that.ui.container.offsetWidth;
        that.setActiveItem(that.activeItemIndex);
      }
    }

    function showNextSlideHandler(e) {
      if (that.nextButtonDisabled) return;
      e.preventDefault();
      that.setActiveItem(that.activeItemIndex + that.slideBy());
    }

    function showPrevSlideHandler(e) {
      if (that.prevButtonDisabled) return;
      e.preventDefault();
      that.setActiveItem(that.activeItemIndex - that.slideBy());
    }

    window.addEventListener('resize', windowResizeHandler);    

    if (this.ui.nextButton) {
      this.ui.nextButton.addEventListener('click', showNextSlideHandler);
    }
    
    if (this.ui.prevButton) {
      this.ui.prevButton.addEventListener('click', showPrevSlideHandler);
    }
  }


  enableSwipes() {
    
    const that = this

    function swipeLeftHandler(e) {
      if (that.nextButtonDisabled) return;
      that.setActiveItem(that.activeItemIndex + that.swipeBy(e.deltaX));
    }

    function swipeRightHandler(e) {
      if (that.prevButtonDisabled) return;
      that.setActiveItem(that.activeItemIndex - that.swipeBy(e.deltaX));
    }

    let hammertime = new Hammer(this.ui.content, {
      enable: true,
      recognizers: [
          [Hammer.Swipe, { 
            direction: Hammer.DIRECTION_HORIZONTAL,
            threshold: 2,
            velocity: 0.2
           }
          ]
      ]
    });

    hammertime.on('swipeleft', swipeLeftHandler);
    hammertime.on('swiperight', swipeRightHandler);

  }  

  slideBy() {
    return (this.containerWidth < 440) ?  TextSlider.SLIDE_BY_SMALL_SCREEN : TextSlider.SLIDE_BY_WIDE_SCREEN;
  }


  swipeBy(deltaX) {
    const dx = Math.abs(deltaX)
    
    if (dx > this.containerWidth / 2) {
      return TextSlider.SWIPE_LARGE
    }
    
    if (dx > this.containerWidth / 3) {
      return TextSlider.SWIPE_MEDIUM
    }
    
    return TextSlider.SWIPE_SMALL
  }


  setActiveItem(itemIndex) {
    
    let activeIndex = itemIndex

    if (activeIndex < this.minItemIndex) {
      activeIndex = this.minItemIndex;
    }

    if (activeIndex > this.maxItemIndex) {
      activeIndex = this.maxItemIndex
    }

    this.offset = this.contentItemsData[activeIndex].left;
    this.ui.content.style.transform = `translateX(-${this.offset}px)`;
    this.activeItemIndex = activeIndex;
    this.updateButtons();
  }

  updateButtons() {
    this.prevButtonDisabled = this.shouldPrevButtonBeDisabled();
    this.nextButtonDisabled = this.shouldNextButtonBeDisabled();

    if (this.prevButtonDisabled) {
      this.disableButton(this.ui.prevButton)
    }
    else {
      this.enableButton(this.ui.prevButton)
    }

    if (this.nextButtonDisabled) {
      this.disableButton(this.ui.nextButton)
    }
    else {
      this.enableButton(this.ui.nextButton)
    }
  };


  shouldPrevButtonBeDisabled() {
    return (this.activeItemIndex == 0);
  }

  shouldNextButtonBeDisabled() {
    let remainingWidth = 0;
    for (var i = this.activeItemIndex; i < this.contentItemsData.length; i++) {
      remainingWidth = remainingWidth + this.contentItemsData[i].width;
    }
    return (remainingWidth <= this.containerWidth);
  }




  disableButton(button) {
    button.classList.add('text-slider__control--disabled');
  }

  enableButton(button) {
    button.classList.remove('text-slider__control--disabled');
  }

}

export default TextSlider;

